import cx from "classnames";
import { DashedMetric } from "common/DashedMetric";
import { SectionBox } from "common/styleguide/SectionBox";
import { useFormatMessage } from "lib/localization";
import p from "prop-types";
import React from "react";
import { defineMessages } from "react-intl";
import { Link } from "react-router-dom";
import styles from "./QuickStats.scss";

const messages = defineMessages({
  today: {
    id: "QuickStats.today",
    defaultMessage: "today",
  },
  thisWeek: {
    id: "QuickStats.thisWeek",
    defaultMessage: "this week",
  },
  thisMonth: {
    id: "QuickStats.thisMonth",
    defaultMessage: "this month",
  },
  thisYear: {
    id: "QuickStats.thisYear",
    defaultMessage: "this year",
  },
});

const messageMap = {
  today: messages.today,
  "this week": messages.thisWeek,
  "this month": messages.thisMonth,
  "this year": messages.thisYear,
};

export const QuickStats = ({ totals, rows, title, to, link, labelsUnder, bottomMargin, className }) => {
  const width = rows && rows <= 4 ? `${25 * rows}%` : "25%";
  const fm = useFormatMessage();

  return (
    <SectionBox title={title || "Stats"} noPadding className={className}>
      <div className={styles.inner}>
        {["today", "this week", "this month", "this year"].map((v, i) => (
          <DashedMetric
            key={i}
            label={fm(messageMap[v])}
            value={totals && totals.hasOwnProperty(v) && totals[`${v}`]}
            width={width}
            className={cx(styles.metric, labelsUnder && styles.labelsUnder, bottomMargin && styles.bottomMargin)}
          />
        ))}
        {to && link && (
          <Link to={to} className={styles.link}>
            {link}
          </Link>
        )}
      </div>
    </SectionBox>
  );
};

QuickStats.propTypes = {
  totals: p.shape({
    today: p.number.isRequired,
    "this week": p.number.isRequired,
    "this month": p.number.isRequired,
    "this year": p.number.isRequired,
  }),
  rows: p.number, // only pass 1, 2, or 4 for rows if you know what's good for you
};
